import { useCallback, type Dispatch, type SetStateAction } from "react";
import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";
import { dismissNotaryContactEmailModalForSession } from "./notaryMissingContactEmailDismiss";
import { persistNotaryContactEmail } from "./notaryMissingContactEmailPersist";
import { useNotaryMissingContactEmailFormState } from "./useNotaryMissingContactEmailFormState";

export function useNotaryMissingContactEmailForm(
	setOpen: Dispatch<SetStateAction<boolean>>,
	refetchUser: () => Promise<void>,
	refreshPermissionContext: () => Promise<void>,
): {
	emailInput: string;
	setEmailInput: (v: string) => void;
	error: string | null;
	saving: boolean;
	handleLater: () => void;
	handleSave: () => Promise<void>;
} {
	const { emailInput, setEmailInput, error, setError, saving, setSaving } = useNotaryMissingContactEmailFormState();

	const handleLater = useCallback(() => {
		dismissNotaryContactEmailModalForSession(setOpen);
	}, [setOpen]);

	const handleSave = useCallback(async () => {
		setSaving(true);
		setError(null);
		const result = await persistNotaryContactEmail(emailInput, refetchUser, setOpen, refreshPermissionContext);
		setSaving(false);
		if (result.ok) {
			return;
		}
		if (result.reason === "invalid_email") {
			setError(COMMON_UI_I18N.folderMessages.confrerePreferredEmailFormatError);
			return;
		}
		setError(COMMON_UI_I18N.folderMessages.notaryMissingContactEmailModalSaveError);
	}, [emailInput, refetchUser, refreshPermissionContext, setOpen, setError, setSaving]);

	return {
		emailInput,
		setEmailInput,
		error,
		saving,
		handleLater,
		handleSave,
	};
}
